module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("To Bill and Sally Smythe,")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Who took us to the edge of the Out Of and")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("made it fun despite the sweat,")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("the lack of sleep, and the tsetse flies,")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("This book is dedicated with friendship and affection.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238f345f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section2.vue
// module id = 69
// module chunks = 0